const ArmorBreakRendering = {
	render: function( data, gameBoard, isCaverns ) {
    const actorSprite = gameBoard.getAllPieceSprites()[data.actorId];
    const render_movement = !isCaverns || actorSprite.gamePiece.hero;
		if (render_movement) {
			actorSprite.puppet.getMovements().armorBreak.movePuppet({ transitTime: actorSprite.puppet.getCooldown() });
		}		
	}
};
export default ArmorBreakRendering;